var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content dashboard", attrs: { id: "app" } },
    [
      !_vm.isLoaded
        ? _c("div", { staticClass: "fancy-loader-container" }, [
            _c("div", { staticClass: "fancy-loader" }),
            _vm._v(" "),
            _c("p", { staticClass: "loader-text" }, [_vm._v("Loading...")]),
          ])
        : _c("div", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "dash-item col-sm-6" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/supplier/invoices" },
                      slot: "item-title",
                    },
                    [
                      _c("div", { staticClass: "dashbox" }, [
                        _c("div", { staticClass: "desc" }, [
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(_vm._s(_vm.getTotalDueAmount)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("dashboard.cards.due_amount")) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "icon" },
                          [_c("invoice-icon", { staticClass: "card-icon" })],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dash-item col-sm-6" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/supplier/customers" },
                      slot: "item-title",
                    },
                    [
                      _c("div", { staticClass: "dashbox" }, [
                        _c("div", { staticClass: "desc" }, [
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(_vm._s(_vm.getContacts)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("dashboard.cards.customers")) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "icon" },
                          [_c("contact-icon", { staticClass: "card-icon" })],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dash-item col-sm-6" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/supplier/invoices" },
                      slot: "item-title",
                    },
                    [
                      _c("div", { staticClass: "dashbox" }, [
                        _c("div", { staticClass: "desc" }, [
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(_vm._s(_vm.getInvoices)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("dashboard.cards.invoices")) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "icon" },
                          [_c("invoice-icon", { staticClass: "card-icon" })],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dash-item col-sm-6" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/supplier/purchase-orders",
                      },
                      slot: "item-title",
                    },
                    [
                      _c("div", { staticClass: "dashbox" }, [
                        _c("div", { staticClass: "desc" }, [
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(_vm._s(_vm.getPurchaseOrders)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t("dashboard.cards.purchase_orders")
                                ) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "icon" },
                          [_c("estimate-icon", { staticClass: "card-icon" })],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-12 mt-2 px-4" }, [
                  _c(
                    "div",
                    { staticClass: "styled-select" },
                    [
                      _c("base-select", {
                        attrs: {
                          options: _vm.invoiceType,
                          "allow-empty": false,
                          "show-labels": false,
                          placeholder: _vm.$t("Select Invoice Type"),
                        },
                        model: {
                          value: _vm.selectedDiv,
                          callback: function ($$v) {
                            _vm.selectedDiv = $$v
                          },
                          expression: "selectedDiv",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-12 mt-2 px-4" }, [
                  _c("div", { staticClass: "card dashboard-card" }, [
                    _c("div", { staticClass: "graph-body" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "card-body col-md-12 col-lg-12 col-xl-10",
                        },
                        [
                          _c("div", { staticClass: "card-header" }, [
                            _c("h6", [
                              _c("i", {
                                staticClass: "fa fa-line-chart text-primary",
                              }),
                              _vm._v(
                                _vm._s(
                                  _vm.$t("dashboard.monthly_chart.title")
                                ) + "\n                  "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "year-selector" },
                              [
                                _c("base-select", {
                                  attrs: {
                                    options: _vm.years,
                                    "allow-empty": false,
                                    "show-labels": false,
                                    placeholder: _vm.$t(
                                      "dashboard.select_year"
                                    ),
                                  },
                                  model: {
                                    value: _vm.selectedYear,
                                    callback: function ($$v) {
                                      _vm.selectedYear = $$v
                                    },
                                    expression: "selectedYear",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("line-chart", {
                            attrs: {
                              "format-money": _vm.$utils.formatMoney,
                              "format-graph-money": _vm.$utils.formatGraphMoney,
                              invoices: _vm.getChartInvoices,
                              labels: _vm.getChartMonths,
                              "outstanding-invoices":
                                _vm.getChartOutstandingInvoices,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "chart-desc col-md-12 col-lg-12 col-xl-2",
                        },
                        [
                          _c("div", { staticClass: "stats" }, [
                            _c("div", { staticClass: "description" }, [
                              _c("span", { staticClass: "title" }, [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.$t("dashboard.chart_info.total_sales")
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { staticClass: "total" }, [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$utils.formatMoney(
                                        _vm.getTotalSales,
                                        _vm.defaultCurrency
                                      )
                                    ),
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _c("span", { staticClass: "title" }, [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.$t(
                                        "dashboard.chart_info.total_outstanding_invoice"
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "total",
                                  staticStyle: { color: "#1E88E5" },
                                },
                                [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$utils.formatMoney(
                                          _vm.getTotalOutstandingInvoices,
                                          _vm.defaultCurrency
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.selectedDiv === "Invoice" ||
                        _vm.selectedDiv === "All",
                      expression:
                        "selectedDiv === 'Invoice' || selectedDiv === 'All'",
                    },
                  ],
                },
                [_c("InvoiceDashboard")],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.selectedDiv === "Preapproved Invoice" ||
                        _vm.selectedDiv === "All",
                      expression:
                        "selectedDiv === 'Preapproved Invoice' || selectedDiv === 'All'",
                    },
                  ],
                },
                [_c("PreapprovedInvoiceDashboard")],
                1
              ),
            ]),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }